import { render, staticRenderFns } from "./ImportarXmlConvenio.vue?vue&type=template&id=cbce6b88&scoped=true"
import script from "./ImportarXmlConvenio.vue?vue&type=script&lang=ts"
export * from "./ImportarXmlConvenio.vue?vue&type=script&lang=ts"
import style0 from "./ImportarXmlConvenio.vue?vue&type=style&index=0&id=cbce6b88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbce6b88",
  null
  
)

export default component.exports